import { render, staticRenderFns } from "./gruposexames.vue?vue&type=template&id=23c7effb&"
import script from "./gruposexames.vue?vue&type=script&lang=js&"
export * from "./gruposexames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports